const data = {
  drawings: [
    {
      id: 1,
      title: 'Puff',
      description: "colored pencil on paper",
      size: "22 x 30 inches",
      year: "2025",
      image: require("./../img/drawings/puff.jpg"),
    },
          {
      id: 2,
      title: 'Tum',
      description: "colored pencil on paper",
      size: "22 x 30 inches",
      year: "2025",
      image: require("./../img/drawings/tum.jpg"),
    },
          {
      id: 3,
      title: 'Ow',
      description: "colored pencil on paper",
      size: "22 x 30 inches",
      year: "2025",
      image: require("./../img/drawings/ow.jpg"),
    },
          {
      id: 4,
      title: 'Hide',
      description: "graphite pencil on paper",
      size: "11 x 14 inches",
      year: "2025",
      image: require("./../img/drawings/hide.jpg"),
    },
          {
      id: 5,
      title: 'Hiss',
      description: "colored pencil on paper",
      size: "14 x 11 inches",
      year: "2025",
      image: require("./../img/drawings/hiss.jpg"),
    },
    {
      id: 6,
      title: 'Snugs',
      description: "colored pencil on paper",
      size: "14 x 11 inches",
      year: "2026",
      image: require("./../img/drawings/snugs.jpg"),
    },
          {
      id: 7,
      title: 'Strength',
      description: "colored pencil on paper",
      size: "14 x 17 inches",
      year: "2025",
      image: require("./../img/drawings/strength.jpg"),
    },
          {
      id: 8,
      title: 'Boop',
      description: "colored pencil on paper",
      size: "14 x 17 inches",
      year: "2024",
      image: require("./../img/drawings/boop.jpg"),
    },
    {
      id: 9,
      title: '42.3516° N, 107.4573° W, at 30,000 ft',
      description: "colored pencil on paper",
      size: "22 x 30 inches",
      year: "2024",
      image: require("./../img/drawings/clouds.jpg"),
    },
    {
      id: 10,
      title: '38°20.22.9 N 87°33.29.5 W',
      description: "colored pencil on paper",
      size: "22 x 30 inches",
      year: "2024",
      image: require("./../img/drawings/willow.jpg"),
    },
    {
      id: 11,
      title: '44.6498° N, 120.2667° W',
      description: "colored pencil on paper",
      size: "22 x 30 inches",
      year: "2023",
      image: require("./../img/drawings/hills.jpg"),
    },
    {
      id: 12,
      title: '46.2496° N, 122.1369° W',
      description: "graphite pencil on paper",
      size: "22 x 30 inches",
      year: "2022",
      image: require("./../img/drawings/rock.jpg"),
    },
    {
      id: 13,
      title: '46.2956° N, 122.2522° W',
      description: "graphite pencil on paper",
      size: "22 x 30 inches",
      year: "2022",
      image: require("./../img/drawings/water.jpg"),
    },
    {
      id: 14,
      title: '38.1123° N, 109.5311° W',
      description: "graphite pencil on paper",
      size: "22 x 30 inches",
      year: "2022",
      image: require("./../img/drawings/dirt.jpg"),
    },
    {
      id: 15,
      title: 'Spirit Lake Cloud',
      description: "graphite pencil on paper",
      size: "22 x 30 inches",
      year: "2021",
      image: require("./../img/drawings/sl-cloud.jpg"),
    },
    {
      id: 16,
      title: 'Spirit Lake Tarot',
      description: "graphite pencil on paper",
      size: "22 x 30 inches",
      year: "2021",
      image: require("./../img/drawings/tarot.jpg"),
    },
    {
      id: 17,
      title: 'Perseus',
      description: "graphite pencil on paper",
      size: "22 x 30 inches",
      year: "2021",
      image: require("./../img/drawings/perseus.jpg"),
    },
    {
      id: 18,
      title: 'Cabin Interior',
      description: "graphite pencil on paper",
      size: "22 x 30 inches",
      year: "2020",
      image: require("./../img/drawings/cabin-interior.jpg"),
    },
    {
      id: 19,
      title: 'Google Map',
      description: "graphite pencil on paper",
      size: "22 x 30 inches",
      year: "2020",
      image: require("./../img/drawings/google-map.jpg"),
    },
    {
      id: 20,
      title: 'Supernova',
      description: "graphite pencil on paper",
      size: "22 x 30 inches",
      year: "2020",
      image: require("./../img/drawings/supernova.jpg"),
    },
    {
      id: 21,
      title: 'Lunar Eclipse',
      description: "colored pencil pencil on paper",
      size: "12 x 18 inches",
      year: "2023",
      image: require("./../img/drawings/eclipse.jpg"),
    },
  ],
};

export default data;